export default "https://cdn1.saucelabs.com/web-ui/images/assets/04dca00896a0f9cb7c61941bad886081.png";